import React, { useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { Loader } from "semantic-ui-react";
import useSuspiciousActivity from "@common/components/hooks/useSuspiciousActivity";
import SuspiciousActivityForm from "@common/components/shared/SuspiciousActivity/SuspiciousActivityForm";
import useComplianceView from "@hooks/useComplianceView.js";
import { SUSPICIOUS_ACTIVITY_TYPE } from "../details/EventDetailsForm.js";
import { parseSuspiciousActivityResponse } from "@common/components/helpers/compliance.js";
import ComplianceHeader from "../ComplianceHeader.js";
import useIncidentContainer from "@hooks/useIncidentContainer.js";
import useLinkedAlert from "@common/components/hooks/useLinkedAlert.js";
import useLinkSession from "@common/components/hooks/useLinkSession";

const SuspiciousActivityContainer = () => {
  const {
    methods,
    methods: { reset },
  } = useSuspiciousActivity();
  const {
    formLoading,
    incident: {
      record,
      record: {
        incidentType: { name },
        alerts,
      },
    },
  } = useComplianceView();
  const { onRowUpdate } = useIncidentContainer();
  const { getComplianceSessionsByGuids } = useLinkSession();
  const { setState } = useLinkedAlert();

  useEffect(() => {
    if (name !== SUSPICIOUS_ACTIVITY_TYPE) {
      return;
    }
    reset(parseSuspiciousActivityResponse(record));

    const sessionGuids = record?.compliance?.sessions?.map(
      (x) => x.sessionGuid,
    );
    if (sessionGuids) {
      getComplianceSessionsByGuids("", sessionGuids);
    }
    setState({ linkedAlertData: alerts });
  }, [record]);

  if (formLoading) {
    return <Loader active />;
  }

  return (
    <FormProvider {...methods}>
      <ComplianceHeader title="Suspicious Activity" loadRecord={onRowUpdate} />
      <SuspiciousActivityForm />
    </FormProvider>
  );
};

export default SuspiciousActivityContainer;
